export default "__VITE_ASSET__JNI5_YRV__"